<template>
  <PageLayout
    class="faq-detail"
    title=""
    :showLangChoose="false"
    :clickLeft="back"
  >
    <div class="faq-detail-wrap">
      <van-loading v-if="loadingPage" class="loading" size="48" />
      <template v-else>
        <faq-notice-bar :source="locationType.faqDetailPage"></faq-notice-bar>
        <div class="faq-detail-content">
          <p class="faq-detail-content-title">{{ faqInfo.title }}</p>
          <p class="faq-detail-content-time">
            {{ languages.smartOrderUpdateTime }}：{{ faqInfo.time }}
          </p>
          <div
            class="faq-detail-content-text"
            v-html="faqInfo.content"
            @click="handleATagHref"
          ></div>
        </div>
        <template v-if="showLike">
          <p class="faq-detail-help-tip">{{ languages.smartOrderIsHelp }}</p>
          <div class="faq-detail-like">
            <em
              class="faq-detail-like-btn like icon iconfont icon-like"
              :class="{ active: isLike }"
              @click="handleLike"
            ></em></div
        ></template>
        <!-- <ContactServerBtn
          :source="locationType.faqDetailPage"
        ></ContactServerBtn> -->
      </template>
    </div>
  </PageLayout>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import PageLayout from '@components/officialSupport/common/PageLayout.vue';
import FaqNoticeBar from '@components/officialSupport/FaqNoticeBar.vue';
import ContactServerBtn from '@components/officialSupport/ContactServerBtn.vue';
import faqLike from '@mixins/officialSupport/faqLike';
import {
  pageType,
  locationType
} from '@plugins/biPoint/_configOfficialSupport';
import pointStayTime from '@mixins/officialSupport/pointStayTime';
import globalConfig from '@utiles/globalConfig';
export default {
  name: 'WorkFaqDetail',
  mixins: [faqLike, pointStayTime],
  data() {
    return {
      faqInfo: {
        id: '',
        title: '',
        time: '',
        content: '',
        liked: 0
      },
      loadingPage: false,
      locationType
    };
  },
  computed: {
    ...mapState({
      languages: state => state.languages,
      letter: state => state.languages?.mywork,
      faqSiteName: state => state.faqSiteName
    }),
    faqId() {
      return this.$route.query.faqId;
    }
  },
  watch: {
    '$route.query.faqId': {
      handler: async function (val, oldVal) {
        if (val && val !== oldVal) {
          window.csorderDataLayer.push({
            eventName: 'view_page',
            eventType: pageType.faqDetailPage,
            eventValue: { faqId: val }
          });
          this.initFaqInfo();
          this.showLike && this.updateLikeData();
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions(['getFaqDetail']),
    back() {
      if (globalConfig.isTiktokMiniProgram()) {
        this.$router.push('/workfaqlist');
      } else {
        this.$router.go(-1);
      }
    },
    async initFaqInfo() {
      try {
        this.loadingPage = true;
        const data = await this.getFaqDetail({ id: this.faqId });
        let { ID, TITLE, EDIT_TIME, CONTENT, liked } = data;
        // 若CONTENT中包含形如[[账号找回]](# 'smartTemp-账号找回-10')的内容，将其替换为<a title="smartTemp-账号找回-10">[账号找回]</a>的形式
        const reg = /\[\[(.*?)\]\]\(# 'smartTemp-(.*?)-(\d+)'\)/g;
        CONTENT = CONTENT.replace(reg, (match, p1, p2, p3) => {
          return `<a title="smartTemp-${p2}-${p3}" href="javascript:;">[${p1}]</a>`;
        });
        this.faqInfo.id = ID;
        this.faqInfo.title = TITLE;
        this.faqInfo.time = EDIT_TIME;
        this.faqInfo.content = CONTENT;
        this.faqInfo.liked = liked;
        this.loadingPage = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleATagHref(event) {
      const target = event.target || event.srcElement;
      if (target.nodeName.toLocaleLowerCase() !== 'a') {
        return;
      }
      const title = target.getAttribute('title') || '';
      if (title && title.includes('smartTemp-')) {
        const id = title?.split('-')?.pop();
        if (id) {
          this.$router.push({
            name: 'worktemp',
            query: {
              workTempId: id,
              source: locationType.faqDetailPage
            }
          });
        }
      }
    }
  },
  components: {
    PageLayout,
    FaqNoticeBar,
    ContactServerBtn
  }
};
</script>
<style lang="scss" scoped>
$img: '~@assets/image/officialSupport/';
.faq-detail {
  padding-bottom: 150px;
  &-wrap {
    padding: 0 10px;
    box-sizing: border-box;
  }
  &-content {
    margin: 0 auto;
    width: 100%;
    background: var(--block-bg-light-color);
    border-radius: 16px;
    padding: 20px 10px;
    font-size: 16px;
    color: var(--text-color);
    box-sizing: border-box;
    &-title {
      font-size: 18px;
      font-weight: 500;
      line-height: 20px;
      word-break: break-word;
      user-select: text;
    }
    &-time {
      font-weight: 350;
      line-height: 20px;
      color: #9e9e9e;
      margin: 20px 0;
    }
    &-text {
      line-height: 200%;
      font-size: 16px;
      word-break: break-word;
      user-select: text;
      ::v-deep img {
        max-width: 100% !important;
        height: auto !important;
      }
      ::v-deep h1 {
        font-size: 38px;
        color: var(--text-color);
      }
      ::v-deep h2 {
        font-size: 32px;
        color: var(--text-color);
      }
      ::v-deep h3 {
        font-size: 30px;
        color: var(--text-color);
      }
      ::v-deep strong {
        font-weight: bolder;
      }
    }
  }
  &-help-tip {
    font-size: 16px;
    line-height: 20px;
    color: var(--text-color);
    text-align: center;
    margin-top: 45px;
  }
  &-like {
    display: flex;
    justify-content: center;
    width: 100%;
    margin: 60px auto 0;
    &-btn {
      font-size: 44px;
      &.like {
        &.active {
          color: var(--main-color);
        }
      }
    }
  }
}
</style>
